/**
 * This is an auto-generated file. Do not edit. Run `./icons_metadata_generator.rb` to regenerate.
 *
 * List of Font Awesome icons to include in the IconLibrary, with keywords.
 * Exported from https://github.com/FortAwesome/Font-Awesome/blob/master/src/icons.yml
 * Licensed CC BY 3.0
 *
 * (Font Awesome by Dave Gandy - http://fontawesome.io/)
 */
module.exports = {
  aliases: {
    music: [
      'music',
      'headphones',
      'volume-off',
      'volume-down',
      'volume-up',
      'play'
    ],
    note: ['music', 'comment', 'comment-o'],
    sound: [
      'music',
      'headphones',
      'volume-off',
      'volume-down',
      'volume-up',
      'play',
      'microphone',
      'microphone-slash'
    ],
    search: ['search'],
    magnify: ['search', 'search-plus', 'search-minus'],
    zoom: ['search', 'search-plus', 'search-minus'],
    enlarge: ['search', 'search-plus', 'expand', 'arrows-alt'],
    bigger: ['search', 'search-plus', 'expand', 'arrows-alt'],
    'envelope-o': ['envelope-o'],
    email: ['envelope-o', 'envelope'],
    support: [
      'envelope-o',
      'question-circle',
      'phone',
      'phone-square',
      'envelope',
      'ambulance',
      'medkit',
      'question',
      'ticket',
      'life-ring'
    ],
    'e-mail': ['envelope-o', 'envelope'],
    letter: ['envelope-o', 'envelope'],
    mail: ['envelope-o', 'envelope'],
    notification: [
      'envelope-o',
      'flag',
      'exclamation-circle',
      'exclamation-triangle',
      'comment',
      'comments',
      'bell',
      'envelope',
      'comment-o',
      'comments-o',
      'bell-o',
      'circle',
      'flag-o',
      'flag-checkered',
      'exclamation',
      'dot-circle-o'
    ],
    heart: ['heart', 'gratipay'],
    love: ['heart', 'heart-o', 'gratipay'],
    like: ['heart', 'thumbs-o-up', 'heart-o', 'thumbs-up', 'gratipay'],
    favorite: ['heart', 'thumbs-o-up', 'heart-o', 'thumbs-up', 'gratipay'],
    star: ['star', 'certificate'],
    award: ['star', 'star-o', 'star-half', 'trophy', 'star-half-o', 'shield'],
    achievement: [
      'star',
      'star-o',
      'star-half',
      'trophy',
      'star-half-o',
      'shield'
    ],
    night: ['star', 'star-o', 'moon-o'],
    rating: [
      'star',
      'star-o',
      'star-half',
      'smile-o',
      'frown-o',
      'meh-o',
      'star-half-o'
    ],
    score: ['star', 'star-o', 'star-half', 'star-half-o'],
    'star-o': ['star-o'],
    user: ['user', 'female', 'male'],
    person: ['user', 'female', 'male', 'wheelchair'],
    man: ['user', 'male'],
    head: ['user'],
    profile: ['user', 'user-md', 'female', 'male'],
    film: ['film', 'video-camera', 'youtube-square', 'youtube'],
    movie: ['film', 'video-camera', 'ticket'],
    'th-large': ['th-large'],
    blocks: ['th-large', 'th'],
    squares: ['th-large', 'th'],
    boxes: ['th-large', 'th'],
    grid: ['th-large', 'th'],
    th: ['th'],
    'th-list': ['th-list'],
    ul: ['th-list', 'list-alt', 'list', 'bars', 'list-ul', 'list-ol'],
    ol: ['th-list', 'list-alt', 'list', 'bars', 'list-ul', 'list-ol'],
    checklist: ['th-list', 'list-alt', 'list', 'bars', 'list-ul', 'list-ol'],
    finished: ['th-list', 'list-alt', 'list'],
    completed: ['th-list', 'list-alt', 'list'],
    done: [
      'th-list',
      'check',
      'list-alt',
      'list',
      'check-square-o',
      'check-circle',
      'check-circle-o',
      'check-square'
    ],
    todo: [
      'th-list',
      'check',
      'list-alt',
      'list',
      'check-square-o',
      'check-circle',
      'check-circle-o',
      'bars',
      'list-ul',
      'list-ol',
      'check-square'
    ],
    check: ['check'],
    checkmark: ['check', 'check-square'],
    agree: [
      'check',
      'check-square-o',
      'check-circle',
      'check-circle-o',
      'thumbs-o-up',
      'check-square',
      'thumbs-up'
    ],
    accept: [
      'check',
      'check-square-o',
      'check-circle',
      'check-circle-o',
      'check-square'
    ],
    confirm: [
      'check',
      'check-square-o',
      'check-circle',
      'check-circle-o',
      'check-square'
    ],
    tick: ['check'],
    ok: [
      'check',
      'check-square-o',
      'check-circle',
      'check-circle-o',
      'check-square',
      'calendar-check-o'
    ],
    times: ['times'],
    close: ['times', 'times', 'times-circle', 'times-circle-o'],
    exit: ['times', 'times-circle', 'times-circle-o', 'sign-out'],
    x: ['times', 'times-circle', 'times-circle-o'],
    cross: ['times'],
    remove: [
      'times',
      'trash-o',
      'minus-circle',
      'ban',
      'minus',
      'chain-broken',
      'minus-square',
      'minus-square-o',
      'trash'
    ],
    'search-plus': ['search-plus'],
    'search-minus': ['search-minus'],
    minify: ['search-minus', 'minus', 'minus-square', 'minus-square-o'],
    smaller: ['search-minus', 'compress'],
    'power-off': ['power-off'],
    on: ['power-off'],
    signal: ['signal'],
    cog: ['cog'],
    settings: ['cog', 'cogs', 'wrench', 'tasks', 'bars'],
    gear: ['cog'],
    'trash-o': ['trash-o'],
    garbage: ['trash-o', 'trash'],
    delete: [
      'trash-o',
      'minus-circle',
      'ban',
      'minus',
      'minus-square',
      'minus-square-o',
      'trash'
    ],
    trash: [
      'trash-o',
      'minus-circle',
      'ban',
      'minus',
      'minus-square',
      'minus-square-o',
      'trash'
    ],
    hide: [
      'trash-o',
      'minus-circle',
      'ban',
      'minus',
      'minus',
      'eye-slash',
      'minus-square',
      'minus-square',
      'minus-square-o',
      'minus-square-o',
      'trash'
    ],
    home: ['home'],
    main: ['home'],
    house: ['home'],
    'file-o': ['file-o'],
    new: [
      'file-o',
      'plus-circle',
      'plus',
      'external-link',
      'file-text-o',
      'plus-square',
      'external-link-square',
      'file',
      'file-text',
      'plus-square-o'
    ],
    page: ['file-o', 'file-text-o', 'file', 'file-text'],
    pdf: ['file-o', 'file-text-o', 'file', 'file-text'],
    document: ['file-o', 'file-text-o', 'file', 'file-text'],
    'clock-o': ['clock-o'],
    watch: ['clock-o'],
    timer: ['clock-o'],
    late: ['clock-o'],
    timestamp: ['clock-o'],
    road: ['road'],
    street: ['road'],
    download: [
      'download',
      'arrow-circle-o-down',
      'arrow-down',
      'arrow-circle-down'
    ],
    import: ['download', 'upload', 'cloud-download', 'cloud-upload'],
    'arrow-circle-o-down': ['arrow-circle-o-down'],
    'arrow-circle-o-up': ['arrow-circle-o-up'],
    inbox: ['inbox'],
    'play-circle-o': ['play-circle-o'],
    repeat: ['repeat'],
    redo: ['repeat'],
    forward: [
      'repeat',
      'forward',
      'forward',
      'chevron-right',
      'arrow-right',
      'hand-o-right',
      'arrow-circle-right',
      'caret-right',
      'angle-double-right',
      'angle-right',
      'chevron-circle-right',
      'caret-square-o-right',
      'arrow-circle-o-right'
    ],
    'rotate-right': ['repeat'],
    refresh: ['refresh', 'retweet'],
    reload: ['refresh', 'retweet'],
    sync: ['refresh'],
    'list-alt': ['list-alt'],
    lock: ['lock', 'unlock', 'unlock-alt'],
    protect: ['lock', 'unlock', 'unlock-alt'],
    admin: ['lock', 'unlock', 'unlock-alt'],
    flag: ['flag'],
    report: ['flag', 'flag-o', 'flag-checkered', 'bug'],
    notify: ['flag', 'flag-checkered', 'exclamation'],
    headphones: ['headphones'],
    listen: ['headphones'],
    'volume-off': ['volume-off'],
    mute: ['volume-off', 'microphone-slash'],
    'volume-down': ['volume-down'],
    lower: ['volume-down'],
    quieter: ['volume-down'],
    'volume-up': ['volume-up'],
    higher: ['volume-up'],
    louder: ['volume-up', 'bullhorn'],
    qrcode: ['qrcode'],
    scan: ['qrcode', 'barcode'],
    barcode: ['barcode'],
    tag: ['tag'],
    label: ['tag'],
    tags: ['tags'],
    labels: ['tags'],
    book: ['book'],
    read: ['book'],
    documentation: ['book'],
    bookmark: ['bookmark'],
    save: ['bookmark', 'bookmark-o', 'hdd-o', 'cloud', 'floppy-o'],
    print: ['print'],
    camera: ['camera'],
    photo: ['camera', 'picture-o', 'camera-retro'],
    picture: ['camera', 'camera-retro'],
    record: [
      'camera',
      'video-camera',
      'camera-retro',
      'microphone',
      'microphone-slash'
    ],
    font: ['font'],
    text: [
      'font',
      'align-left',
      'align-center',
      'align-right',
      'align-justify',
      'mobile'
    ],
    bold: ['bold'],
    italic: ['italic'],
    italics: ['italic'],
    'text-height': ['text-height'],
    'text-width': ['text-width'],
    'align-left': ['align-left'],
    'align-center': ['align-center'],
    middle: ['align-center'],
    'align-right': ['align-right'],
    'align-justify': ['align-justify'],
    list: ['list', 'bars', 'bars', 'list-ul', 'list-ol', 'list-ol'],
    outdent: ['outdent'],
    dedent: ['outdent'],
    indent: ['indent'],
    'video-camera': ['video-camera'],
    'picture-o': ['picture-o'],
    image: ['picture-o'],
    pencil: ['pencil'],
    write: ['pencil', 'pencil-square-o', 'pencil-square'],
    edit: ['pencil', 'pencil-square-o', 'pencil-square-o', 'pencil-square'],
    update: ['pencil', 'pencil-square-o', 'wrench', 'pencil-square'],
    'map-marker': ['map-marker'],
    map: ['map-marker', 'globe', 'location-arrow', 'street-view', 'map'],
    pin: ['map-marker', 'thumb-tack'],
    location: [
      'map-marker',
      'plane',
      'thumb-tack',
      'globe',
      'location-arrow',
      'compass'
    ],
    coordinates: ['map-marker', 'thumb-tack', 'globe', 'location-arrow'],
    localize: ['map-marker', 'globe'],
    address: ['map-marker', 'location-arrow'],
    travel: ['map-marker', 'plane', 'globe', 'suitcase', 'bed'],
    where: ['map-marker', 'location-arrow'],
    place: ['map-marker', 'globe', 'location-arrow'],
    adjust: ['adjust'],
    contrast: ['adjust', 'sun-o', 'moon-o'],
    tint: ['tint'],
    raindrop: ['tint'],
    waterdrop: ['tint'],
    drop: ['tint'],
    droplet: ['tint'],
    'pencil-square-o': ['pencil-square-o'],
    'share-square-o': ['share-square-o'],
    social: ['share-square-o', 'share-square'],
    send: ['share-square-o', 'share-square', 'paper-plane'],
    'check-square-o': ['check-square-o'],
    arrows: ['arrows', 'exchange'],
    move: ['arrows', 'arrows-alt', 'suitcase'],
    reorder: ['arrows', 'arrows-alt', 'bars', 'bars'],
    resize: ['arrows', 'expand', 'arrows-v', 'arrows-h', 'arrows-alt'],
    'step-backward': ['step-backward'],
    rewind: ['step-backward', 'fast-backward', 'backward'],
    previous: [
      'step-backward',
      'fast-backward',
      'backward',
      'chevron-left',
      'arrow-left',
      'hand-o-left',
      'arrow-circle-left',
      'caret-left',
      'angle-double-left',
      'angle-left',
      'chevron-circle-left',
      'long-arrow-left',
      'arrow-circle-o-left',
      'caret-square-o-left'
    ],
    beginning: ['step-backward', 'fast-backward'],
    start: [
      'step-backward',
      'fast-backward',
      'play',
      'play-circle',
      'youtube-play'
    ],
    first: ['step-backward', 'fast-backward'],
    'fast-backward': ['fast-backward'],
    backward: ['backward'],
    play: ['play'],
    playing: ['play', 'play-circle', 'youtube-play'],
    pause: ['pause'],
    wait: ['pause'],
    stop: ['stop', 'ban'],
    block: ['stop', 'ban', 'square-o', 'square'],
    box: ['stop', 'square-o', 'square', 'archive'],
    square: ['stop', 'square-o', 'square'],
    next: [
      'forward',
      'fast-forward',
      'step-forward',
      'chevron-right',
      'arrow-right',
      'hand-o-right',
      'arrow-circle-right',
      'caret-right',
      'angle-double-right',
      'angle-right',
      'chevron-circle-right',
      'caret-square-o-right',
      'arrow-circle-o-right'
    ],
    'fast-forward': ['fast-forward'],
    end: ['fast-forward', 'step-forward'],
    last: ['fast-forward', 'step-forward'],
    'step-forward': ['step-forward'],
    eject: ['eject'],
    'chevron-left': ['chevron-left'],
    bracket: ['chevron-left', 'chevron-right'],
    back: [
      'chevron-left',
      'arrow-left',
      'hand-o-left',
      'arrow-circle-left',
      'caret-left',
      'undo',
      'angle-double-left',
      'angle-left',
      'chevron-circle-left',
      'long-arrow-left',
      'arrow-circle-o-left',
      'caret-square-o-left'
    ],
    'chevron-right': ['chevron-right'],
    'plus-circle': ['plus-circle'],
    add: ['plus-circle', 'plus', 'plus-square', 'plus-square-o', 'cart-plus'],
    create: ['plus-circle', 'plus', 'plus-square', 'plus-square-o'],
    expand: [
      'plus-circle',
      'expand',
      'plus',
      'arrows-alt',
      'plus-square',
      'plus-square-o'
    ],
    'minus-circle': ['minus-circle'],
    'times-circle': ['times-circle'],
    'check-circle': ['check-circle'],
    'question-circle': ['question-circle'],
    help: [
      'question-circle',
      'info-circle',
      'ambulance',
      'medkit',
      'question',
      'info'
    ],
    information: ['question-circle', 'info-circle', 'question', 'info'],
    unknown: ['question-circle', 'question'],
    'info-circle': ['info-circle'],
    more: [
      'info-circle',
      'caret-down',
      'sort-desc',
      'info',
      'chevron-circle-down',
      'caret-square-o-down'
    ],
    details: ['info-circle', 'asterisk', 'info'],
    'times-circle-o': ['times-circle-o'],
    'check-circle-o': ['check-circle-o'],
    ban: ['ban'],
    abort: ['ban'],
    cancel: ['ban'],
    'arrow-left': ['arrow-left'],
    'arrow-right': ['arrow-right'],
    'arrow-up': ['arrow-up'],
    'arrow-down': ['arrow-down'],
    share: ['share', 'retweet', 'bullhorn'],
    'mail-forward': ['share'],
    compress: ['compress'],
    collapse: ['compress', 'minus', 'minus-square', 'minus-square-o'],
    combine: ['compress'],
    contract: ['compress'],
    merge: ['compress', 'code-fork'],
    plus: ['plus'],
    minus: ['minus'],
    asterisk: ['asterisk'],
    'exclamation-circle': ['exclamation-circle'],
    warning: [
      'exclamation-circle',
      'exclamation-triangle',
      'exclamation-triangle',
      'exclamation'
    ],
    error: ['exclamation-circle', 'exclamation-triangle', 'exclamation'],
    problem: ['exclamation-circle', 'exclamation-triangle', 'exclamation'],
    alert: [
      'exclamation-circle',
      'exclamation-triangle',
      'bell',
      'bell-o',
      'exclamation'
    ],
    gift: ['gift'],
    present: ['gift'],
    leaf: ['leaf', 'pagelines'],
    eco: ['leaf', 'pagelines'],
    nature: ['leaf', 'pagelines'],
    fire: ['fire'],
    flame: ['fire'],
    hot: ['fire'],
    popular: ['fire'],
    eye: ['eye'],
    show: ['eye', 'eye-slash'],
    visible: ['eye', 'eye-slash'],
    views: ['eye', 'eye-slash'],
    'eye-slash': ['eye-slash'],
    toggle: ['eye-slash'],
    visiblity: ['eye-slash'],
    'exclamation-triangle': ['exclamation-triangle'],
    plane: ['plane'],
    trip: ['plane', 'suitcase'],
    destination: ['plane'],
    airplane: ['plane'],
    fly: ['plane'],
    mode: ['plane'],
    calendar: ['calendar'],
    date: ['calendar', 'calendar-o'],
    time: ['calendar', 'calendar-o'],
    when: ['calendar', 'calendar-o'],
    random: ['random'],
    sort: ['random', 'sort'],
    shuffle: ['random'],
    comment: ['comment'],
    speech: ['comment', 'comment-o'],
    chat: ['comment', 'comment-o'],
    bubble: ['comment', 'comment-o'],
    feedback: ['comment', 'comment-o'],
    message: [
      'comment',
      'comments',
      'comment-o',
      'comments-o',
      'commenting',
      'commenting-o'
    ],
    texting: ['comment', 'comments', 'comment-o', 'comments-o'],
    sms: ['comment', 'comments', 'comment-o', 'comments-o'],
    magnet: ['magnet'],
    'chevron-up': ['chevron-up'],
    'chevron-down': ['chevron-down'],
    retweet: ['retweet'],
    'shopping-cart': ['shopping-cart'],
    checkout: ['shopping-cart', 'credit-card', 'money', 'credit-card-alt'],
    buy: ['shopping-cart', 'credit-card', 'money', 'credit-card-alt'],
    purchase: ['shopping-cart', 'credit-card', 'money', 'credit-card-alt'],
    payment: ['shopping-cart', 'credit-card', 'money', 'credit-card-alt'],
    folder: ['folder'],
    'folder-open': ['folder-open'],
    'arrows-v': ['arrows-v'],
    'arrows-h': ['arrows-h'],
    'bar-chart': ['bar-chart'],
    graph: ['bar-chart', 'area-chart', 'pie-chart', 'line-chart'],
    analytics: ['bar-chart', 'area-chart', 'pie-chart', 'line-chart'],
    'bar-chart-o': ['bar-chart'],
    'twitter-square': ['twitter-square'],
    tweet: ['twitter-square', 'twitter'],
    'social network': [
      'twitter-square',
      'facebook-square',
      'twitter',
      'facebook',
      'google-plus-square',
      'google-plus'
    ],
    'facebook-square': ['facebook-square'],
    'camera-retro': ['camera-retro'],
    key: ['key'],
    unlock: ['key', 'unlock'],
    password: ['key', 'unlock', 'unlock-alt'],
    cogs: ['cogs'],
    gears: ['cogs'],
    comments: ['comments'],
    conversation: ['comments', 'comments-o'],
    notes: ['comments', 'comments-o'],
    'thumbs-o-up': ['thumbs-o-up'],
    approve: ['thumbs-o-up', 'smile-o', 'thumbs-up'],
    hand: ['thumbs-o-up', 'thumbs-o-down', 'thumbs-up', 'thumbs-down'],
    'thumbs-o-down': ['thumbs-o-down'],
    dislike: ['thumbs-o-down', 'thumbs-down'],
    disapprove: ['thumbs-o-down', 'frown-o', 'thumbs-down'],
    disagree: ['thumbs-o-down', 'thumbs-down'],
    'star-half': ['star-half'],
    'heart-o': ['heart-o'],
    'sign-out': ['sign-out'],
    'log out': ['sign-out'],
    logout: ['sign-out'],
    leave: ['sign-out'],
    arrow: ['sign-out', 'sign-in', 'exchange'],
    'linkedin-square': ['linkedin-square'],
    'thumb-tack': ['thumb-tack'],
    marker: ['thumb-tack'],
    'external-link': ['external-link'],
    open: ['external-link', 'external-link-square'],
    'sign-in': ['sign-in'],
    enter: ['sign-in'],
    join: ['sign-in'],
    'log in': ['sign-in'],
    login: ['sign-in'],
    'sign up': ['sign-in', 'user-plus'],
    'sign in': ['sign-in'],
    signin: ['sign-in'],
    signup: ['sign-in', 'user-plus'],
    trophy: ['trophy'],
    winner: ['trophy', 'shield'],
    game: ['trophy'],
    'github-square': ['github-square'],
    octocat: ['github-square', 'github', 'github-alt'],
    upload: ['upload'],
    'lemon-o': ['lemon-o'],
    phone: ['phone'],
    call: ['phone', 'phone-square', 'mobile'],
    voice: ['phone', 'phone-square', 'microphone', 'microphone-slash'],
    number: ['phone', 'phone-square', 'mobile'],
    earphone: ['phone'],
    'square-o': ['square-o'],
    'bookmark-o': ['bookmark-o'],
    'phone-square': ['phone-square'],
    twitter: ['twitter'],
    facebook: ['facebook'],
    'facebook-f': ['facebook'],
    github: ['github', 'code-fork'],
    'credit-card': ['credit-card'],
    money: ['credit-card', 'money', 'money', 'credit-card-alt'],
    debit: ['credit-card', 'credit-card-alt'],
    rss: ['rss'],
    blog: ['rss', 'rss-square'],
    feed: ['rss', 'rss-square'],
    'hdd-o': ['hdd-o'],
    harddrive: ['hdd-o'],
    'hard drive': ['hdd-o'],
    storage: ['hdd-o', 'archive'],
    bullhorn: ['bullhorn'],
    announcement: ['bullhorn'],
    broadcast: ['bullhorn'],
    bell: ['bell'],
    reminder: ['bell', 'bell-o'],
    certificate: ['certificate'],
    badge: ['certificate'],
    'hand-o-right': ['hand-o-right'],
    point: ['hand-o-right', 'hand-o-left', 'hand-o-up', 'hand-o-down'],
    right: ['hand-o-right'],
    'hand-o-left': ['hand-o-left'],
    left: ['hand-o-left'],
    'hand-o-up': ['hand-o-up'],
    'hand-o-down': ['hand-o-down'],
    'arrow-circle-left': ['arrow-circle-left'],
    'arrow-circle-right': ['arrow-circle-right'],
    'arrow-circle-up': ['arrow-circle-up'],
    'arrow-circle-down': ['arrow-circle-down'],
    globe: ['globe'],
    world: ['globe'],
    planet: ['globe'],
    earth: ['globe'],
    global: ['globe'],
    translate: ['globe'],
    all: ['globe'],
    language: ['globe', 'language'],
    country: ['globe'],
    wrench: ['wrench'],
    fix: ['wrench'],
    tasks: ['tasks'],
    progress: ['tasks', 'spinner'],
    loading: ['tasks', 'spinner'],
    downloading: ['tasks'],
    downloads: ['tasks'],
    filter: ['filter'],
    funnel: ['filter'],
    options: ['filter'],
    briefcase: ['briefcase'],
    work: ['briefcase', 'building-o', 'building'],
    business: ['briefcase', 'building-o', 'building'],
    office: ['briefcase', 'building-o', 'building'],
    luggage: ['briefcase', 'suitcase'],
    bag: ['briefcase'],
    'arrows-alt': ['arrows-alt'],
    fullscreen: ['arrows-alt'],
    users: ['users'],
    people: ['users'],
    profiles: ['users'],
    persons: ['users'],
    group: ['users'],
    link: ['link', 'anchor'],
    chain: ['link', 'link'],
    cloud: ['cloud'],
    flask: ['flask'],
    science: ['flask'],
    beaker: ['flask'],
    experimental: ['flask'],
    labs: ['flask'],
    scissors: ['scissors'],
    cut: ['scissors'],
    'files-o': ['files-o'],
    duplicate: ['files-o'],
    copy: ['files-o', 'clipboard', 'clone'],
    paperclip: ['paperclip'],
    attachment: ['paperclip'],
    'floppy-o': ['floppy-o'],
    bars: ['bars'],
    menu: [
      'bars',
      'caret-down',
      'sort-desc',
      'chevron-circle-down',
      'compass',
      'caret-square-o-down'
    ],
    drag: ['bars'],
    hamburger: ['bars'],
    navicon: ['bars'],
    'list-ul': ['list-ul'],
    'list-ol': ['list-ol'],
    numbers: ['list-ol', 'sort-numeric-asc', 'sort-numeric-desc'],
    strikethrough: ['strikethrough'],
    underline: ['underline'],
    table: ['table'],
    data: ['table'],
    excel: ['table'],
    spreadsheet: ['table'],
    magic: ['magic'],
    wizard: ['magic'],
    automatic: ['magic'],
    autocomplete: ['magic'],
    truck: ['truck'],
    shipping: ['truck'],
    pinterest: ['pinterest'],
    'pinterest-square': ['pinterest-square'],
    'google-plus-square': ['google-plus-square'],
    'google-plus': ['google-plus'],
    cash: ['money'],
    'caret-down': ['caret-down'],
    dropdown: [
      'caret-down',
      'sort-desc',
      'chevron-circle-down',
      'caret-square-o-down'
    ],
    'triangle down': ['caret-down'],
    'caret-up': ['caret-up'],
    'triangle up': ['caret-up'],
    'caret-left': ['caret-left'],
    'triangle left': ['caret-left'],
    'caret-right': ['caret-right'],
    'triangle right': ['caret-right'],
    columns: ['columns'],
    split: ['columns'],
    panes: ['columns'],
    order: ['sort'],
    unsorted: ['sort'],
    'sort-desc': ['sort-desc'],
    'sort-down': ['sort-desc'],
    'sort-asc': ['sort-asc'],
    'sort-up': ['sort-asc'],
    envelope: ['envelope'],
    linkedin: ['linkedin'],
    undo: ['undo'],
    'rotate-left': ['undo'],
    gavel: ['gavel'],
    legal: ['gavel'],
    tachometer: ['tachometer'],
    dashboard: ['tachometer'],
    'comment-o': ['comment-o'],
    'comments-o': ['comments-o'],
    bolt: ['bolt'],
    lightning: ['bolt'],
    weather: ['bolt', 'sun-o'],
    flash: ['bolt'],
    sitemap: ['sitemap'],
    directory: ['sitemap', 'compass'],
    hierarchy: ['sitemap'],
    organization: ['sitemap'],
    umbrella: ['umbrella'],
    clipboard: ['clipboard'],
    paste: ['clipboard'],
    'lightbulb-o': ['lightbulb-o'],
    idea: ['lightbulb-o'],
    inspiration: ['lightbulb-o'],
    exchange: ['exchange'],
    transfer: ['exchange'],
    'cloud-download': ['cloud-download'],
    'cloud-upload': ['cloud-upload'],
    'user-md': ['user-md'],
    doctor: ['user-md'],
    medical: ['user-md'],
    nurse: ['user-md'],
    stethoscope: ['stethoscope'],
    suitcase: ['suitcase'],
    baggage: ['suitcase'],
    'bell-o': ['bell-o'],
    coffee: ['coffee'],
    morning: ['coffee'],
    mug: ['coffee'],
    breakfast: ['coffee'],
    tea: ['coffee'],
    drink: ['coffee'],
    cafe: ['coffee'],
    cutlery: ['cutlery'],
    food: ['cutlery'],
    restaurant: ['cutlery'],
    spoon: ['cutlery', 'spoon'],
    knife: ['cutlery'],
    dinner: ['cutlery'],
    eat: ['cutlery'],
    'file-text-o': ['file-text-o'],
    'building-o': ['building-o'],
    apartment: ['building-o', 'building'],
    company: ['building-o', 'building'],
    'hospital-o': ['hospital-o'],
    building: ['hospital-o', 'building'],
    ambulance: ['ambulance'],
    medkit: ['medkit'],
    'first aid': ['medkit'],
    firstaid: ['medkit'],
    health: ['medkit'],
    'h-square': ['h-square'],
    hospital: ['h-square'],
    hotel: ['h-square', 'bed'],
    'plus-square': ['plus-square'],
    'angle-double-left': ['angle-double-left'],
    laquo: ['angle-double-left'],
    quote: ['angle-double-left', 'angle-double-right'],
    'angle-double-right': ['angle-double-right'],
    raquo: ['angle-double-right'],
    'angle-double-up': ['angle-double-up'],
    'angle-double-down': ['angle-double-down'],
    'angle-left': ['angle-left'],
    'angle-right': ['angle-right'],
    'angle-up': ['angle-up'],
    'angle-down': ['angle-down'],
    desktop: ['desktop', 'desktop'],
    monitor: ['desktop'],
    screen: ['desktop'],
    computer: ['desktop', 'laptop'],
    demo: ['desktop', 'laptop'],
    device: ['desktop', 'laptop', 'tablet'],
    laptop: ['laptop'],
    tablet: ['tablet'],
    ipad: ['tablet'],
    mobile: ['mobile'],
    'cell phone': ['mobile'],
    cellphone: ['mobile'],
    iphone: ['mobile'],
    'mobile-phone': ['mobile'],
    'circle-o': ['circle-o'],
    'quote-left': ['quote-left'],
    'quote-right': ['quote-right'],
    spinner: ['spinner'],
    circle: ['circle'],
    dot: ['circle'],
    reply: ['reply'],
    'mail-reply': ['reply'],
    'github-alt': ['github-alt'],
    'folder-o': ['folder-o'],
    'folder-open-o': ['folder-open-o'],
    'smile-o': ['smile-o'],
    emoticon: ['smile-o', 'frown-o', 'meh-o'],
    happy: ['smile-o'],
    satisfied: ['smile-o'],
    'frown-o': ['frown-o'],
    sad: ['frown-o'],
    'meh-o': ['meh-o'],
    neutral: ['meh-o'],
    gamepad: ['gamepad'],
    controller: ['gamepad'],
    'keyboard-o': ['keyboard-o'],
    type: ['keyboard-o'],
    input: ['keyboard-o'],
    'flag-o': ['flag-o'],
    'flag-checkered': ['flag-checkered'],
    terminal: ['terminal'],
    command: ['terminal'],
    prompt: ['terminal'],
    code: ['terminal', 'code', 'css3'],
    html: ['code'],
    brackets: ['code'],
    'reply-all': ['reply-all'],
    'mail-reply-all': ['reply-all'],
    'star-half-o': ['star-half-o'],
    'star-half-empty': ['star-half-o'],
    'star-half-full': ['star-half-o'],
    'location-arrow': ['location-arrow'],
    crop: ['crop'],
    'code-fork': ['code-fork'],
    git: ['code-fork', 'bitbucket', 'bitbucket-square', 'git'],
    fork: ['code-fork'],
    vcs: ['code-fork'],
    svn: ['code-fork'],
    rebase: ['code-fork'],
    version: ['code-fork'],
    'chain-broken': ['chain-broken'],
    unlink: ['chain-broken'],
    question: ['question'],
    info: ['info'],
    exclamation: ['exclamation'],
    superscript: ['superscript'],
    exponential: ['superscript'],
    subscript: ['subscript'],
    eraser: ['eraser'],
    'puzzle-piece': ['puzzle-piece'],
    addon: ['puzzle-piece'],
    'add-on': ['puzzle-piece'],
    section: ['puzzle-piece'],
    microphone: ['microphone'],
    'microphone-slash': ['microphone-slash'],
    shield: ['shield'],
    'calendar-o': ['calendar-o'],
    'fire-extinguisher': ['fire-extinguisher'],
    rocket: ['rocket'],
    app: ['rocket'],
    maxcdn: ['maxcdn'],
    'chevron-circle-left': ['chevron-circle-left'],
    'chevron-circle-right': ['chevron-circle-right'],
    'chevron-circle-up': ['chevron-circle-up'],
    'chevron-circle-down': ['chevron-circle-down'],
    html5: ['html5'],
    css3: ['css3'],
    anchor: ['anchor'],
    'unlock-alt': ['unlock-alt'],
    bullseye: ['bullseye', 'dot-circle-o'],
    target: ['bullseye', 'dot-circle-o'],
    'ellipsis-h': ['ellipsis-h'],
    dots: ['ellipsis-h', 'ellipsis-v'],
    'ellipsis-v': ['ellipsis-v'],
    'rss-square': ['rss-square'],
    'play-circle': ['play-circle'],
    ticket: ['ticket'],
    pass: ['ticket'],
    'minus-square': ['minus-square'],
    'minus-square-o': ['minus-square-o'],
    'level-up': ['level-up'],
    'level-down': ['level-down'],
    'check-square': ['check-square'],
    'pencil-square': ['pencil-square'],
    'external-link-square': ['external-link-square'],
    'share-square': ['share-square'],
    compass: ['compass'],
    safari: ['compass', 'safari'],
    'caret-square-o-down': ['caret-square-o-down'],
    'toggle-down': ['caret-square-o-down'],
    'caret-square-o-up': ['caret-square-o-up'],
    'toggle-up': ['caret-square-o-up'],
    'caret-square-o-right': ['caret-square-o-right'],
    'toggle-right': ['caret-square-o-right'],
    eur: ['eur'],
    euro: ['eur'],
    gbp: ['gbp'],
    usd: ['usd'],
    dollar: ['usd'],
    inr: ['inr'],
    rupee: ['inr'],
    jpy: ['jpy'],
    cny: ['jpy'],
    rmb: ['jpy'],
    yen: ['jpy'],
    rub: ['rub'],
    ruble: ['rub'],
    rouble: ['rub'],
    krw: ['krw'],
    won: ['krw'],
    btc: ['btc'],
    bitcoin: ['btc'],
    file: ['file'],
    'file-text': ['file-text'],
    'sort-alpha-asc': ['sort-alpha-asc'],
    'sort-alpha-desc': ['sort-alpha-desc'],
    'sort-amount-asc': ['sort-amount-asc'],
    'sort-amount-desc': ['sort-amount-desc'],
    'sort-numeric-asc': ['sort-numeric-asc'],
    'sort-numeric-desc': ['sort-numeric-desc'],
    'thumbs-up': ['thumbs-up'],
    'thumbs-down': ['thumbs-down'],
    'youtube-square': ['youtube-square'],
    video: ['youtube-square', 'youtube'],
    youtube: ['youtube'],
    xing: ['xing'],
    'xing-square': ['xing-square'],
    'youtube-play': ['youtube-play'],
    dropbox: ['dropbox'],
    'stack-overflow': ['stack-overflow'],
    instagram: ['instagram'],
    flickr: ['flickr'],
    adn: ['adn'],
    bitbucket: ['bitbucket'],
    'bitbucket-square': ['bitbucket-square'],
    tumblr: ['tumblr'],
    'tumblr-square': ['tumblr-square'],
    'long-arrow-down': ['long-arrow-down'],
    'long-arrow-up': ['long-arrow-up'],
    'long-arrow-left': ['long-arrow-left'],
    'long-arrow-right': ['long-arrow-right'],
    apple: ['apple'],
    osx: ['apple'],
    windows: ['windows'],
    microsoft: ['windows'],
    android: ['android'],
    linux: ['linux'],
    tux: ['linux'],
    dribbble: ['dribbble'],
    skype: ['skype'],
    foursquare: ['foursquare'],
    trello: ['trello'],
    female: ['female'],
    woman: ['female'],
    male: ['male'],
    gratipay: ['gratipay'],
    gittip: ['gratipay'],
    'sun-o': ['sun-o'],
    lighter: ['sun-o'],
    brighten: ['sun-o'],
    day: ['sun-o'],
    'moon-o': ['moon-o'],
    darker: ['moon-o'],
    archive: ['archive'],
    bug: ['bug'],
    insect: ['bug'],
    vk: ['vk'],
    weibo: ['weibo'],
    renren: ['renren'],
    pagelines: ['pagelines'],
    leaves: ['pagelines'],
    tree: ['pagelines', 'tree'],
    plant: ['pagelines'],
    'stack-exchange': ['stack-exchange'],
    'arrow-circle-o-right': ['arrow-circle-o-right'],
    'arrow-circle-o-left': ['arrow-circle-o-left'],
    'caret-square-o-left': ['caret-square-o-left'],
    'toggle-left': ['caret-square-o-left'],
    'dot-circle-o': ['dot-circle-o'],
    wheelchair: ['wheelchair'],
    handicap: ['wheelchair'],
    accessibility: ['wheelchair'],
    accessibile: ['wheelchair'],
    'vimeo-square': ['vimeo-square'],
    try: ['try'],
    'turkish-lira': ['try'],
    'plus-square-o': ['plus-square-o'],
    'space-shuttle': ['space-shuttle'],
    slack: ['slack'],
    'envelope-square': ['envelope-square'],
    wordpress: ['wordpress'],
    openid: ['openid'],
    university: ['university'],
    institution: ['university'],
    bank: ['university'],
    'graduation-cap': ['graduation-cap'],
    learning: ['graduation-cap'],
    school: ['graduation-cap'],
    student: ['graduation-cap'],
    'mortar-board': ['graduation-cap'],
    yahoo: ['yahoo'],
    google: ['google'],
    reddit: ['reddit'],
    'reddit-square': ['reddit-square'],
    'stumbleupon-circle': ['stumbleupon-circle'],
    stumbleupon: ['stumbleupon'],
    delicious: ['delicious'],
    digg: ['digg'],
    'pied-piper': ['pied-piper'],
    'pied-piper-alt': ['pied-piper-alt'],
    drupal: ['drupal'],
    joomla: ['joomla'],
    fax: ['fax'],
    child: ['child'],
    paw: ['paw'],
    pet: ['paw'],
    cube: ['cube'],
    cubes: ['cubes'],
    behance: ['behance'],
    'behance-square': ['behance-square'],
    steam: ['steam'],
    'steam-square': ['steam-square'],
    recycle: ['recycle'],
    car: ['car'],
    vehicle: ['car', 'taxi', 'bicycle', 'bus', 'motorcycle'],
    automobile: ['car'],
    taxi: ['taxi'],
    cab: ['taxi'],
    spotify: ['spotify'],
    deviantart: ['deviantart'],
    soundcloud: ['soundcloud'],
    database: ['database'],
    'file-pdf-o': ['file-pdf-o'],
    'file-word-o': ['file-word-o'],
    'file-excel-o': ['file-excel-o'],
    'file-powerpoint-o': ['file-powerpoint-o'],
    'file-image-o': ['file-image-o'],
    'file-photo-o': ['file-image-o'],
    'file-picture-o': ['file-image-o'],
    'file-archive-o': ['file-archive-o'],
    'file-zip-o': ['file-archive-o'],
    'file-audio-o': ['file-audio-o'],
    'file-sound-o': ['file-audio-o'],
    'file-video-o': ['file-video-o'],
    'file-movie-o': ['file-video-o'],
    'file-code-o': ['file-code-o'],
    vine: ['vine'],
    codepen: ['codepen'],
    jsfiddle: ['jsfiddle'],
    'life-ring': ['life-ring'],
    'life-bouy': ['life-ring'],
    'life-buoy': ['life-ring'],
    'life-saver': ['life-ring'],
    'circle-o-notch': ['circle-o-notch'],
    rebel: ['rebel'],
    ra: ['rebel'],
    empire: ['empire'],
    ge: ['empire'],
    'git-square': ['git-square'],
    'hacker-news': ['hacker-news'],
    'y-combinator-square': ['hacker-news'],
    'yc-square': ['hacker-news'],
    'tencent-weibo': ['tencent-weibo'],
    qq: ['qq'],
    weixin: ['weixin'],
    wechat: ['weixin'],
    'paper-plane': ['paper-plane'],
    'paper-plane-o': ['paper-plane-o'],
    'send-o': ['paper-plane-o'],
    history: ['history'],
    'circle-thin': ['circle-thin'],
    header: ['header'],
    heading: ['header'],
    paragraph: ['paragraph'],
    sliders: ['sliders'],
    'share-alt': ['share-alt'],
    'share-alt-square': ['share-alt-square'],
    'futbol-o': ['futbol-o'],
    'soccer-ball-o': ['futbol-o'],
    tty: ['tty'],
    binoculars: ['binoculars'],
    plug: ['plug'],
    slideshare: ['slideshare'],
    twitch: ['twitch'],
    yelp: ['yelp'],
    'newspaper-o': ['newspaper-o'],
    press: ['newspaper-o'],
    wifi: ['wifi'],
    calculator: ['calculator'],
    paypal: ['paypal'],
    'google-wallet': ['google-wallet'],
    'cc-visa': ['cc-visa'],
    'cc-mastercard': ['cc-mastercard'],
    'cc-discover': ['cc-discover'],
    'cc-amex': ['cc-amex'],
    amex: ['cc-amex'],
    'cc-paypal': ['cc-paypal'],
    'cc-stripe': ['cc-stripe'],
    'bell-slash': ['bell-slash'],
    'bell-slash-o': ['bell-slash-o'],
    copyright: ['copyright'],
    at: ['at'],
    eyedropper: ['eyedropper'],
    'paint-brush': ['paint-brush'],
    'birthday-cake': ['birthday-cake'],
    'area-chart': ['area-chart'],
    'pie-chart': ['pie-chart'],
    'line-chart': ['line-chart'],
    lastfm: ['lastfm'],
    'lastfm-square': ['lastfm-square'],
    'toggle-off': ['toggle-off'],
    'toggle-on': ['toggle-on'],
    bicycle: ['bicycle'],
    bike: ['bicycle', 'motorcycle'],
    bus: ['bus'],
    ioxhost: ['ioxhost'],
    angellist: ['angellist'],
    cc: ['cc'],
    ils: ['ils'],
    shekel: ['ils'],
    sheqel: ['ils'],
    meanpath: ['meanpath'],
    buysellads: ['buysellads'],
    connectdevelop: ['connectdevelop'],
    dashcube: ['dashcube'],
    forumbee: ['forumbee'],
    leanpub: ['leanpub'],
    sellsy: ['sellsy'],
    shirtsinbulk: ['shirtsinbulk'],
    simplybuilt: ['simplybuilt'],
    skyatlas: ['skyatlas'],
    'cart-plus': ['cart-plus'],
    shopping: ['cart-plus', 'cart-arrow-down'],
    'cart-arrow-down': ['cart-arrow-down'],
    diamond: ['diamond'],
    gem: ['diamond'],
    gemstone: ['diamond'],
    ship: ['ship'],
    boat: ['ship'],
    sea: ['ship'],
    'user-secret': ['user-secret'],
    whisper: ['user-secret'],
    spy: ['user-secret'],
    incognito: ['user-secret'],
    motorcycle: ['motorcycle'],
    'street-view': ['street-view'],
    heartbeat: ['heartbeat'],
    ekg: ['heartbeat'],
    'facebook-official': ['facebook-official'],
    'pinterest-p': ['pinterest-p'],
    whatsapp: ['whatsapp'],
    server: ['server'],
    'user-plus': ['user-plus'],
    'user-times': ['user-times'],
    bed: ['bed'],
    viacoin: ['viacoin'],
    train: ['train'],
    subway: ['subway'],
    medium: ['medium'],
    'y-combinator': ['y-combinator'],
    yc: ['y-combinator'],
    'optin-monster': ['optin-monster'],
    opencart: ['opencart'],
    expeditedssl: ['expeditedssl'],
    'battery-full': ['battery-full'],
    'battery-4': ['battery-full'],
    'battery-three-quarters': ['battery-three-quarters'],
    'battery-3': ['battery-three-quarters'],
    'battery-half': ['battery-half'],
    'battery-2': ['battery-half'],
    'battery-quarter': ['battery-quarter'],
    'battery-1': ['battery-quarter'],
    'battery-empty': ['battery-empty'],
    'battery-0': ['battery-empty'],
    'mouse-pointer': ['mouse-pointer'],
    'i-cursor': ['i-cursor'],
    'object-group': ['object-group'],
    'object-ungroup': ['object-ungroup'],
    'sticky-note': ['sticky-note'],
    'sticky-note-o': ['sticky-note-o'],
    'cc-jcb': ['cc-jcb'],
    'cc-diners-club': ['cc-diners-club'],
    clone: ['clone'],
    'balance-scale': ['balance-scale'],
    'hourglass-o': ['hourglass-o'],
    'hourglass-start': ['hourglass-start'],
    'hourglass-1': ['hourglass-start'],
    'hourglass-half': ['hourglass-half'],
    'hourglass-2': ['hourglass-half'],
    'hourglass-end': ['hourglass-end'],
    'hourglass-3': ['hourglass-end'],
    hourglass: ['hourglass'],
    'hand-rock-o': ['hand-rock-o'],
    'hand-grab-o': ['hand-rock-o'],
    'hand-paper-o': ['hand-paper-o'],
    'hand-stop-o': ['hand-paper-o'],
    'hand-scissors-o': ['hand-scissors-o'],
    'hand-lizard-o': ['hand-lizard-o'],
    'hand-spock-o': ['hand-spock-o'],
    'hand-pointer-o': ['hand-pointer-o'],
    'hand-peace-o': ['hand-peace-o'],
    trademark: ['trademark'],
    registered: ['registered'],
    'creative-commons': ['creative-commons'],
    gg: ['gg'],
    'gg-circle': ['gg-circle'],
    tripadvisor: ['tripadvisor'],
    odnoklassniki: ['odnoklassniki'],
    'odnoklassniki-square': ['odnoklassniki-square'],
    'get-pocket': ['get-pocket'],
    'wikipedia-w': ['wikipedia-w'],
    browser: ['safari', 'chrome', 'firefox', 'internet-explorer', 'edge'],
    chrome: ['chrome'],
    firefox: ['firefox'],
    opera: ['opera'],
    'internet-explorer': ['internet-explorer'],
    ie: ['internet-explorer', 'edge'],
    television: ['television'],
    tv: ['television'],
    contao: ['contao'],
    '500px': ['500px'],
    amazon: ['amazon'],
    'calendar-plus-o': ['calendar-plus-o'],
    'calendar-minus-o': ['calendar-minus-o'],
    'calendar-times-o': ['calendar-times-o'],
    'calendar-check-o': ['calendar-check-o'],
    industry: ['industry'],
    factory: ['industry'],
    'map-pin': ['map-pin'],
    'map-signs': ['map-signs'],
    'map-o': ['map-o'],
    commenting: ['commenting'],
    'commenting-o': ['commenting-o'],
    houzz: ['houzz'],
    vimeo: ['vimeo'],
    'black-tie': ['black-tie'],
    fonticons: ['fonticons'],
    'reddit-alien': ['reddit-alien'],
    edge: ['edge'],
    'credit-card-alt': ['credit-card-alt'],
    'credit card': ['credit-card-alt'],
    codiepie: ['codiepie'],
    modx: ['modx'],
    'fort-awesome': ['fort-awesome'],
    usb: ['usb'],
    'product-hunt': ['product-hunt'],
    mixcloud: ['mixcloud'],
    scribd: ['scribd'],
    'pause-circle': ['pause-circle'],
    'pause-circle-o': ['pause-circle-o'],
    'stop-circle': ['stop-circle'],
    'stop-circle-o': ['stop-circle-o'],
    'shopping-bag': ['shopping-bag'],
    'shopping-basket': ['shopping-basket'],
    hashtag: ['hashtag'],
    bluetooth: ['bluetooth'],
    'bluetooth-b': ['bluetooth-b'],
    percent: ['percent']
  },
  unicode: {
    music: 'f001',
    search: 'f002',
    'envelope-o': 'f003',
    heart: 'f004',
    star: 'f005',
    'star-o': 'f006',
    user: 'f007',
    film: 'f008',
    'th-large': 'f009',
    th: 'f00a',
    'th-list': 'f00b',
    check: 'f00c',
    times: 'f00d',
    'search-plus': 'f00e',
    'search-minus': 'f010',
    'power-off': 'f011',
    signal: 'f012',
    cog: 'f013',
    'trash-o': 'f014',
    home: 'f015',
    'file-o': 'f016',
    'clock-o': 'f017',
    road: 'f018',
    download: 'f019',
    'arrow-circle-o-down': 'f01a',
    'arrow-circle-o-up': 'f01b',
    inbox: 'f01c',
    'play-circle-o': 'f01d',
    repeat: 'f01e',
    refresh: 'f021',
    'list-alt': 'f022',
    lock: 'f023',
    flag: 'f024',
    headphones: 'f025',
    'volume-off': 'f026',
    'volume-down': 'f027',
    'volume-up': 'f028',
    qrcode: 'f029',
    barcode: 'f02a',
    tag: 'f02b',
    tags: 'f02c',
    book: 'f02d',
    bookmark: 'f02e',
    print: 'f02f',
    camera: 'f030',
    font: 'f031',
    bold: 'f032',
    italic: 'f033',
    'text-height': 'f034',
    'text-width': 'f035',
    'align-left': 'f036',
    'align-center': 'f037',
    'align-right': 'f038',
    'align-justify': 'f039',
    list: 'f03a',
    outdent: 'f03b',
    indent: 'f03c',
    'video-camera': 'f03d',
    'picture-o': 'f03e',
    pencil: 'f040',
    'map-marker': 'f041',
    adjust: 'f042',
    tint: 'f043',
    'pencil-square-o': 'f044',
    'share-square-o': 'f045',
    'check-square-o': 'f046',
    arrows: 'f047',
    'step-backward': 'f048',
    'fast-backward': 'f049',
    backward: 'f04a',
    play: 'f04b',
    pause: 'f04c',
    stop: 'f04d',
    forward: 'f04e',
    'fast-forward': 'f050',
    'step-forward': 'f051',
    eject: 'f052',
    'chevron-left': 'f053',
    'chevron-right': 'f054',
    'plus-circle': 'f055',
    'minus-circle': 'f056',
    'times-circle': 'f057',
    'check-circle': 'f058',
    'question-circle': 'f059',
    'info-circle': 'f05a',
    'times-circle-o': 'f05c',
    'check-circle-o': 'f05d',
    ban: 'f05e',
    'arrow-left': 'f060',
    'arrow-right': 'f061',
    'arrow-up': 'f062',
    'arrow-down': 'f063',
    share: 'f064',
    expand: 'f065',
    compress: 'f066',
    plus: 'f067',
    minus: 'f068',
    asterisk: 'f069',
    'exclamation-circle': 'f06a',
    gift: 'f06b',
    leaf: 'f06c',
    fire: 'f06d',
    eye: 'f06e',
    'eye-slash': 'f070',
    'exclamation-triangle': 'f071',
    plane: 'f072',
    calendar: 'f073',
    random: 'f074',
    comment: 'f075',
    magnet: 'f076',
    'chevron-up': 'f077',
    'chevron-down': 'f078',
    retweet: 'f079',
    'shopping-cart': 'f07a',
    folder: 'f07b',
    'folder-open': 'f07c',
    'arrows-v': 'f07d',
    'arrows-h': 'f07e',
    'bar-chart': 'f080',
    'twitter-square': 'f081',
    'facebook-square': 'f082',
    'camera-retro': 'f083',
    key: 'f084',
    cogs: 'f085',
    comments: 'f086',
    'thumbs-o-up': 'f087',
    'thumbs-o-down': 'f088',
    'star-half': 'f089',
    'heart-o': 'f08a',
    'sign-out': 'f08b',
    'linkedin-square': 'f08c',
    'thumb-tack': 'f08d',
    'external-link': 'f08e',
    'sign-in': 'f090',
    trophy: 'f091',
    'github-square': 'f092',
    upload: 'f093',
    'lemon-o': 'f094',
    phone: 'f095',
    'square-o': 'f096',
    'bookmark-o': 'f097',
    'phone-square': 'f098',
    twitter: 'f099',
    facebook: 'f09a',
    github: 'f09b',
    unlock: 'f09c',
    'credit-card': 'f09d',
    rss: 'f09e',
    'hdd-o': 'f0a0',
    bullhorn: 'f0a1',
    bell: 'f0f3',
    certificate: 'f0a3',
    'hand-o-right': 'f0a4',
    'hand-o-left': 'f0a5',
    'hand-o-up': 'f0a6',
    'hand-o-down': 'f0a7',
    'arrow-circle-left': 'f0a8',
    'arrow-circle-right': 'f0a9',
    'arrow-circle-up': 'f0aa',
    'arrow-circle-down': 'f0ab',
    globe: 'f0ac',
    wrench: 'f0ad',
    tasks: 'f0ae',
    filter: 'f0b0',
    briefcase: 'f0b1',
    'arrows-alt': 'f0b2',
    users: 'f0c0',
    link: 'f0c1',
    cloud: 'f0c2',
    flask: 'f0c3',
    scissors: 'f0c4',
    'files-o': 'f0c5',
    paperclip: 'f0c6',
    'floppy-o': 'f0c7',
    square: 'f0c8',
    bars: 'f0c9',
    'list-ul': 'f0ca',
    'list-ol': 'f0cb',
    strikethrough: 'f0cc',
    underline: 'f0cd',
    table: 'f0ce',
    magic: 'f0d0',
    truck: 'f0d1',
    pinterest: 'f0d2',
    'pinterest-square': 'f0d3',
    'google-plus-square': 'f0d4',
    'google-plus': 'f0d5',
    money: 'f0d6',
    'caret-down': 'f0d7',
    'caret-up': 'f0d8',
    'caret-left': 'f0d9',
    'caret-right': 'f0da',
    columns: 'f0db',
    sort: 'f0dc',
    'sort-desc': 'f0dd',
    'sort-asc': 'f0de',
    envelope: 'f0e0',
    linkedin: 'f0e1',
    undo: 'f0e2',
    gavel: 'f0e3',
    tachometer: 'f0e4',
    'comment-o': 'f0e5',
    'comments-o': 'f0e6',
    bolt: 'f0e7',
    sitemap: 'f0e8',
    umbrella: 'f0e9',
    clipboard: 'f0ea',
    'lightbulb-o': 'f0eb',
    exchange: 'f0ec',
    'cloud-download': 'f0ed',
    'cloud-upload': 'f0ee',
    'user-md': 'f0f0',
    stethoscope: 'f0f1',
    suitcase: 'f0f2',
    'bell-o': 'f0a2',
    coffee: 'f0f4',
    cutlery: 'f0f5',
    'file-text-o': 'f0f6',
    'building-o': 'f0f7',
    'hospital-o': 'f0f8',
    ambulance: 'f0f9',
    medkit: 'f0fa',
    'h-square': 'f0fd',
    'plus-square': 'f0fe',
    'angle-double-left': 'f100',
    'angle-double-right': 'f101',
    'angle-double-up': 'f102',
    'angle-double-down': 'f103',
    'angle-left': 'f104',
    'angle-right': 'f105',
    'angle-up': 'f106',
    'angle-down': 'f107',
    desktop: 'f108',
    laptop: 'f109',
    tablet: 'f10a',
    mobile: 'f10b',
    'circle-o': 'f10c',
    'quote-left': 'f10d',
    'quote-right': 'f10e',
    spinner: 'f110',
    circle: 'f111',
    reply: 'f112',
    'github-alt': 'f113',
    'folder-o': 'f114',
    'folder-open-o': 'f115',
    'smile-o': 'f118',
    'frown-o': 'f119',
    'meh-o': 'f11a',
    gamepad: 'f11b',
    'keyboard-o': 'f11c',
    'flag-o': 'f11d',
    'flag-checkered': 'f11e',
    terminal: 'f120',
    code: 'f121',
    'reply-all': 'f122',
    'star-half-o': 'f123',
    'location-arrow': 'f124',
    crop: 'f125',
    'code-fork': 'f126',
    'chain-broken': 'f127',
    question: 'f128',
    info: 'f129',
    exclamation: 'f12a',
    superscript: 'f12b',
    subscript: 'f12c',
    eraser: 'f12d',
    'puzzle-piece': 'f12e',
    microphone: 'f130',
    'microphone-slash': 'f131',
    shield: 'f132',
    'calendar-o': 'f133',
    'fire-extinguisher': 'f134',
    rocket: 'f135',
    maxcdn: 'f136',
    'chevron-circle-left': 'f137',
    'chevron-circle-right': 'f138',
    'chevron-circle-up': 'f139',
    'chevron-circle-down': 'f13a',
    html5: 'f13b',
    css3: 'f13c',
    anchor: 'f13d',
    'unlock-alt': 'f13e',
    bullseye: 'f140',
    'ellipsis-h': 'f141',
    'ellipsis-v': 'f142',
    'rss-square': 'f143',
    'play-circle': 'f144',
    ticket: 'f145',
    'minus-square': 'f146',
    'minus-square-o': 'f147',
    'level-up': 'f148',
    'level-down': 'f149',
    'check-square': 'f14a',
    'pencil-square': 'f14b',
    'external-link-square': 'f14c',
    'share-square': 'f14d',
    compass: 'f14e',
    'caret-square-o-down': 'f150',
    'caret-square-o-up': 'f151',
    'caret-square-o-right': 'f152',
    eur: 'f153',
    gbp: 'f154',
    usd: 'f155',
    inr: 'f156',
    jpy: 'f157',
    rub: 'f158',
    krw: 'f159',
    btc: 'f15a',
    file: 'f15b',
    'file-text': 'f15c',
    'sort-alpha-asc': 'f15d',
    'sort-alpha-desc': 'f15e',
    'sort-amount-asc': 'f160',
    'sort-amount-desc': 'f161',
    'sort-numeric-asc': 'f162',
    'sort-numeric-desc': 'f163',
    'thumbs-up': 'f164',
    'thumbs-down': 'f165',
    'youtube-square': 'f166',
    youtube: 'f167',
    xing: 'f168',
    'xing-square': 'f169',
    'youtube-play': 'f16a',
    dropbox: 'f16b',
    'stack-overflow': 'f16c',
    instagram: 'f16d',
    flickr: 'f16e',
    adn: 'f170',
    bitbucket: 'f171',
    'bitbucket-square': 'f172',
    tumblr: 'f173',
    'tumblr-square': 'f174',
    'long-arrow-down': 'f175',
    'long-arrow-up': 'f176',
    'long-arrow-left': 'f177',
    'long-arrow-right': 'f178',
    apple: 'f179',
    windows: 'f17a',
    android: 'f17b',
    linux: 'f17c',
    dribbble: 'f17d',
    skype: 'f17e',
    foursquare: 'f180',
    trello: 'f181',
    female: 'f182',
    male: 'f183',
    gratipay: 'f184',
    'sun-o': 'f185',
    'moon-o': 'f186',
    archive: 'f187',
    bug: 'f188',
    vk: 'f189',
    weibo: 'f18a',
    renren: 'f18b',
    pagelines: 'f18c',
    'stack-exchange': 'f18d',
    'arrow-circle-o-right': 'f18e',
    'arrow-circle-o-left': 'f190',
    'caret-square-o-left': 'f191',
    'dot-circle-o': 'f192',
    wheelchair: 'f193',
    'vimeo-square': 'f194',
    try: 'f195',
    'plus-square-o': 'f196',
    'space-shuttle': 'f197',
    slack: 'f198',
    'envelope-square': 'f199',
    wordpress: 'f19a',
    openid: 'f19b',
    university: 'f19c',
    'graduation-cap': 'f19d',
    yahoo: 'f19e',
    google: 'f1a0',
    reddit: 'f1a1',
    'reddit-square': 'f1a2',
    'stumbleupon-circle': 'f1a3',
    stumbleupon: 'f1a4',
    delicious: 'f1a5',
    digg: 'f1a6',
    'pied-piper': 'f1a7',
    'pied-piper-alt': 'f1a8',
    drupal: 'f1a9',
    joomla: 'f1aa',
    language: 'f1ab',
    fax: 'f1ac',
    building: 'f1ad',
    child: 'f1ae',
    paw: 'f1b0',
    spoon: 'f1b1',
    cube: 'f1b2',
    cubes: 'f1b3',
    behance: 'f1b4',
    'behance-square': 'f1b5',
    steam: 'f1b6',
    'steam-square': 'f1b7',
    recycle: 'f1b8',
    car: 'f1b9',
    taxi: 'f1ba',
    tree: 'f1bb',
    spotify: 'f1bc',
    deviantart: 'f1bd',
    soundcloud: 'f1be',
    database: 'f1c0',
    'file-pdf-o': 'f1c1',
    'file-word-o': 'f1c2',
    'file-excel-o': 'f1c3',
    'file-powerpoint-o': 'f1c4',
    'file-image-o': 'f1c5',
    'file-archive-o': 'f1c6',
    'file-audio-o': 'f1c7',
    'file-video-o': 'f1c8',
    'file-code-o': 'f1c9',
    vine: 'f1ca',
    codepen: 'f1cb',
    jsfiddle: 'f1cc',
    'life-ring': 'f1cd',
    'circle-o-notch': 'f1ce',
    rebel: 'f1d0',
    empire: 'f1d1',
    'git-square': 'f1d2',
    git: 'f1d3',
    'hacker-news': 'f1d4',
    'tencent-weibo': 'f1d5',
    qq: 'f1d6',
    weixin: 'f1d7',
    'paper-plane': 'f1d8',
    'paper-plane-o': 'f1d9',
    history: 'f1da',
    'circle-thin': 'f1db',
    header: 'f1dc',
    paragraph: 'f1dd',
    sliders: 'f1de',
    'share-alt': 'f1e0',
    'share-alt-square': 'f1e1',
    'futbol-o': 'f1e3',
    tty: 'f1e4',
    binoculars: 'f1e5',
    plug: 'f1e6',
    slideshare: 'f1e7',
    twitch: 'f1e8',
    yelp: 'f1e9',
    'newspaper-o': 'f1ea',
    wifi: 'f1eb',
    calculator: 'f1ec',
    paypal: 'f1ed',
    'google-wallet': 'f1ee',
    'cc-visa': 'f1f0',
    'cc-mastercard': 'f1f1',
    'cc-discover': 'f1f2',
    'cc-amex': 'f1f3',
    'cc-paypal': 'f1f4',
    'cc-stripe': 'f1f5',
    'bell-slash': 'f1f6',
    'bell-slash-o': 'f1f7',
    trash: 'f1f8',
    copyright: 'f1f9',
    at: 'f1fa',
    eyedropper: 'f1fb',
    'paint-brush': 'f1fc',
    'birthday-cake': 'f1fd',
    'area-chart': 'f1fe',
    'pie-chart': 'f200',
    'line-chart': 'f201',
    lastfm: 'f202',
    'lastfm-square': 'f203',
    'toggle-off': 'f204',
    'toggle-on': 'f205',
    bicycle: 'f206',
    bus: 'f207',
    ioxhost: 'f208',
    angellist: 'f209',
    cc: 'f20a',
    ils: 'f20b',
    meanpath: 'f20c',
    buysellads: 'f20d',
    connectdevelop: 'f20e',
    dashcube: 'f210',
    forumbee: 'f211',
    leanpub: 'f212',
    sellsy: 'f213',
    shirtsinbulk: 'f214',
    simplybuilt: 'f215',
    skyatlas: 'f216',
    'cart-plus': 'f217',
    'cart-arrow-down': 'f218',
    diamond: 'f219',
    ship: 'f21a',
    'user-secret': 'f21b',
    motorcycle: 'f21c',
    'street-view': 'f21d',
    heartbeat: 'f21e',
    'facebook-official': 'f230',
    'pinterest-p': 'f231',
    whatsapp: 'f232',
    server: 'f233',
    'user-plus': 'f234',
    'user-times': 'f235',
    bed: 'f236',
    viacoin: 'f237',
    train: 'f238',
    subway: 'f239',
    medium: 'f23a',
    'y-combinator': 'f23b',
    'optin-monster': 'f23c',
    opencart: 'f23d',
    expeditedssl: 'f23e',
    'battery-full': 'f240',
    'battery-three-quarters': 'f241',
    'battery-half': 'f242',
    'battery-quarter': 'f243',
    'battery-empty': 'f244',
    'mouse-pointer': 'f245',
    'i-cursor': 'f246',
    'object-group': 'f247',
    'object-ungroup': 'f248',
    'sticky-note': 'f249',
    'sticky-note-o': 'f24a',
    'cc-jcb': 'f24b',
    'cc-diners-club': 'f24c',
    clone: 'f24d',
    'balance-scale': 'f24e',
    'hourglass-o': 'f250',
    'hourglass-start': 'f251',
    'hourglass-half': 'f252',
    'hourglass-end': 'f253',
    hourglass: 'f254',
    'hand-rock-o': 'f255',
    'hand-paper-o': 'f256',
    'hand-scissors-o': 'f257',
    'hand-lizard-o': 'f258',
    'hand-spock-o': 'f259',
    'hand-pointer-o': 'f25a',
    'hand-peace-o': 'f25b',
    trademark: 'f25c',
    registered: 'f25d',
    'creative-commons': 'f25e',
    gg: 'f260',
    'gg-circle': 'f261',
    tripadvisor: 'f262',
    odnoklassniki: 'f263',
    'odnoklassniki-square': 'f264',
    'get-pocket': 'f265',
    'wikipedia-w': 'f266',
    safari: 'f267',
    chrome: 'f268',
    firefox: 'f269',
    opera: 'f26a',
    'internet-explorer': 'f26b',
    television: 'f26c',
    contao: 'f26d',
    '500px': 'f26e',
    amazon: 'f270',
    'calendar-plus-o': 'f271',
    'calendar-minus-o': 'f272',
    'calendar-times-o': 'f273',
    'calendar-check-o': 'f274',
    industry: 'f275',
    'map-pin': 'f276',
    'map-signs': 'f277',
    'map-o': 'f278',
    map: 'f279',
    commenting: 'f27a',
    'commenting-o': 'f27b',
    houzz: 'f27c',
    vimeo: 'f27d',
    'black-tie': 'f27e',
    fonticons: 'f280',
    'reddit-alien': 'f281',
    edge: 'f282',
    'credit-card-alt': 'f283',
    codiepie: 'f284',
    modx: 'f285',
    'fort-awesome': 'f286',
    usb: 'f287',
    'product-hunt': 'f288',
    mixcloud: 'f289',
    scribd: 'f28a',
    'pause-circle': 'f28b',
    'pause-circle-o': 'f28c',
    'stop-circle': 'f28d',
    'stop-circle-o': 'f28e',
    'shopping-bag': 'f290',
    'shopping-basket': 'f291',
    hashtag: 'f292',
    bluetooth: 'f293',
    'bluetooth-b': 'f294',
    percent: 'f295'
  }
};
